module.exports = __webpack_public_path__ + "img/9.996bd668.png";